{
  "pageTitle": "News & Events",
  "title1": "School",
  "title2": "News & Events",
  "subtitle": "Stay informed about the latest news, events, and achievements at Manara",
  "allCategories": "All",
  "loadMore": "Load More",
  "postsError": "Failed to get news data"
}
